<!--
  @project E-School Web
  @author Vothana CHY
  @date 2026-07-13
-->

<script lang="ts" setup>
defineProps<{
  img: string;
  alt: string;
  isCenter: boolean;
}>();
</script>

<template>
  <div
    class="phone-card relative h-92.5 w-45 origin-bottom transform-gpu transition-all duration-700 ease-[cubic-bezier(0.16,1,0.3,1)] will-change-transform"
    :class="[
      isCenter ? 'z-10 scale-115 opacity-100 drop-shadow-2xl' : 'scale-85 opacity-40 drop-shadow-md sm:opacity-60',
    ]"
  >
    <!-- Content screen image (object-fill ensures all phone frames are exactly the same size) -->
    <AppImage
      :src="img"
      :alt="alt"
      img-class="h-full w-full object-fill"
      loader-size="h-8 w-8"
      loader-text=""
      loader-overlay-class="bg-white/60"
    />
  </div>
</template>
